import React from "react";
import {connect} from "react-redux";
import {Link} from "react-router-dom";
import {Button, Card} from "reactstrap";
import {useTranslation} from "react-i18next";

import expressLogo from '../../../../assets/utils/images/messenger/express.png';


const ConnectCardExpress = (
    {
        activeShop,
    }
) => {
    const {t, i18n} = useTranslation();

    return <Card className="mb-3 profile-responsive">
        <div className="dropdown-menu-header text-dark">
            <div className="dropdown-menu-header-inner bg-white">
                <div className="menu-header-content btn-pane-right d-block text-center">
                    <h5 className="d-flex align-items-center justify-content-center mb-3">
                        <img src={expressLogo} alt="expressLogo" style={{height: 30}} className='mr-2'/>
                        Express.ms
                    </h5>
                    <h6 className='opacity-6 my-4'>
                        {t('connect_cards.express.caption', 'Automate business processes in the corporate messenger Express')}
                    </h6>
                    <div className="menu-header-btn-pane">
                        <Link to={`/${activeShop.id}/connect/express`}>
                            <Button color="primary">
                                {t('connect_bot.common.submit', 'Connect')}
                            </Button>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    </Card>;
};


const mapStateToProps = state => ({
    activeShop: state.Shops.activeShop,
});

const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(ConnectCardExpress);
